import * as RadixTooltip from '@radix-ui/react-tooltip';
import { css, Z_INDEX_LIBRARY } from '@bts-web/utils-style-engine';

interface TooltipProps extends React.PropsWithChildren {
  content: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
  open: boolean;
}

const tooltipContentStyles = css({
  animation: 'none',
  backgroundColor: 'var(--colors-neutrals-on_fill_light)',
  borderRadius: '12px',
  color: 'var(--colors-neutrals-on_fill_dark)',
  fontSize: 'var(--font-sizes-caption-medium_medium)',
  fontWeight: 'var(--font-weights-caption-medium_medium)',
  lineHeight: 'var(--line-heights-caption-medium_medium)',
  letterSpacing: 'var(--letter-spacings-caption-medium_medium)',
  padding: 'small',
});

export const Tooltip = ({
  children,
  content,
  side = 'bottom',
  open,
}: TooltipProps) => {
  return (
    <RadixTooltip.Provider delayDuration={0}>
      <RadixTooltip.Root open={open}>
        <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <RadixTooltip.Content
            side={side}
            style={{
              zIndex: Z_INDEX_LIBRARY.TOOLTIP,
            }}
            className={tooltipContentStyles}
          >
            {content}
            <RadixTooltip.Arrow />
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
};
